import { Button } from '@smartgift/frontend-toolkit';
import styled, { css } from 'styled-components';

const DonationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--size-4);
`;

const DonationOptionsWrapper = styled.div`
  display: flex;
  gap: 8px;
`;

const DonationOption = styled(Button)`
  border-color: var(--color-bg-strong);
  color: var(--color-fg-weakest);
  flex: 0.25;
  padding: 4px 8px;

  &:hover {
    background: var(--color-bg-stronger);
    color: var(--color-bg-body);
  }

  ${({ active }) =>
    active &&
    css`
      background: var(--color-bg-stronger);
      color: var(--color-bg-body);
    `}
`;

const CustomDonationWrapper = styled.div`
  display: flex;
  gap: 8px;

  ${Button.S.Button} {
    max-width: fit-content;
  }
`;

export { CustomDonationWrapper, DonationOption, DonationOptionsWrapper, DonationWrapper };
